import OrderReviewDrawer from './order-review-drawer.vue';
import BrandResponseDrawer from './brand-review-response/brand-response-drawer.vue';

export default { OrderReviewDrawer, BrandResponseDrawer };
